import { timeUtil } from '@cmg/common';

import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['modifiedAt'];

export const lastUpdatedTimeColDef: ParticipationGridColDef<Value> = {
  field: 'modifiedAt',
  headerName: 'Last Updated',
  type: 'datetime',
  filter: 'agDateColumnFilter',
  floatingFilter: true,
  filterParams: {
    filterOptions: [
      'equals',
      'notEqual',
      'lessThan',
      'greaterThan',
      'inRange',
      'blank',
      'notBlank',
    ],
    includeBlanksInRange: true,
    inRangeInclusive: true,
  },
  valueFormatter: ({ value }) => {
    if (!value) {
      return '-';
    }
    return timeUtil.formatAsMonthDateYearTime(value) ?? '-';
  },
};
